module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAA/ElEQVRYR+3TQUoDQRCF4ao5gLfserMIJARFhSx0oSSiKAqBcesJc4KWBhcSsnuvoRfV+2q++bvGbfDjg/ssgewLZcEsyBZg53MHsyBbgJ2nd3BZlhcAt2ZWWcyleQXwZGY/AFYjA6/M7BPAWo1UFWzAdt4BbJVINdDc/TUiblRIOfAPtgdwr0D2AjbbE4Adi+wJbLZHAA8MsiewTtM0l1K+RwRWd19FxJHBtdkeBRtuHRFfLE4OdPeG25ZSPhQ4OdDMrgG8qXBSYK31bp7ngxKnBB4APKtxKuAGgGznzj+S/ot7VPt/ZwLZwlkwC7IF2PncwSzIFmDnh9/BXzPhVilyBcd5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/icon_2.png
// module id = 7Wse
// module chunks = 1